import { useMutation } from "@apollo/client";
import Button from "components/Button/Button";
import InputField from "components/InputField/InputField";
import Modal from "components/Modal/Modal";
import { disableMarketplaceMutation } from "pages/Marketplaces/mutations";
import { disableUserMutation } from "pages/Users/mutations";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { Marketplace, User } from "TypesAndInterfaces";
import { displayError } from "utils/displayNotification";

interface IProps {
    dataType: string
    isDisableModalOpened: boolean,
    dataToDisable: User | Marketplace,
    setIsDisableModalOpened: Function,
    fetchFunction: Function
}

const DisableForm = ({ dataType, isDisableModalOpened, dataToDisable, setIsDisableModalOpened, fetchFunction } : IProps) => {

    //#region hooks
    const [disableInput, setdisableInput] = useState("");
    const [pageTitle, setPageTitle] = useState("");
    const [question, setQuestion] = useState("");
    //#endregion

    //#region API CALLS
    const [disableUser] = useMutation(disableUserMutation, {
        onCompleted: (dataDisable) => {
          setIsDisableModalOpened(false);
          toast.info(`User disabled.`, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        },
        onError: (error) => {
          console.log('on error')
          displayError(error.message);
        }
      });

      const [disableMarketplace] = useMutation(disableMarketplaceMutation, {
        onCompleted: (dataDisable) => {
          setIsDisableModalOpened(false);
          toast.info(`Marketplace disabled.`, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        },
        onError: (error) => {
          displayError(error.message);
        }
      });
    //#endregion

    const handleIsDisableModalOpened = (isOpened: boolean) => {
        setIsDisableModalOpened(isOpened);
      };

    const handleDisableData = async () => {
      if (disableInput === dataToDisable?.name) {
        if(dataType === "User" ) {
          await disableUser({ variables: { userId: dataToDisable?.id } });
          fetchFunction();
          setIsDisableModalOpened(false);
        } else {
          disableMarketplace({ variables: { id: dataToDisable.id } });
          fetchFunction();
          setIsDisableModalOpened(false);
        }
      }
    }

    useEffect(() => {
      if(dataType === "User") {
        setPageTitle("Disable User");
        setQuestion("Are you sure you want to disable this user?");
      } else {
        setPageTitle("Disable Marketplace");
        setQuestion("Are you sure you want to disable this marketplace?");
      }
    }, [dataToDisable, dataType])

    return (
        <Modal
        isOpened={isDisableModalOpened}
        className="disable"
        title={pageTitle}
        setIsOpenedCallback={handleIsDisableModalOpened}
      >
        <p>
          <strong>{question}</strong>
        </p>
        <p>
          To disable the user, please enter the name "{dataToDisable?.name}"
          below
        </p>
        <InputField
          className={
            "modal-input " +
            (disableInput !== dataToDisable?.name ? "invalid-input" : "")
          }
          placeholder="Enter the text here"
          onChange={(e: any) => setdisableInput(e.target.value)}
          value={disableInput}
        />

        <div className="modal-buttons-container">
          <Button
            className="button--bordered button--error"
            type="button"
            content="Cancel"
            onClick={() => setIsDisableModalOpened(false)}
          ></Button>
          <Button
            className="button--error"
            type="button"
            content="Disable"
            onClick={handleDisableData}
            disabled={disableInput !== dataToDisable?.name}
          ></Button>
        </div>
      </Modal>
    );
};

export default DisableForm;